<template>
    <DesktopMenu v-if="!useMobile && !inGameView" />

    <MobileHeader v-if="useMobile && !inGameView" />
    <div v-if="inGameView" class="flex justify-end p-2">
        <button v-if="game.myGame?.ended" class="rounded-lg px-3 py-2 text-sm text-primary" @click="game.myUuid = undefined">Back to Home</button>
        <button class="rounded-lg px-3 py-2 text-sm text-muted-foreground" @click="gameMenu = true">Menu</button>
    </div>
    <Sheet :open="gameMenu" @update:open="gameMenu = $event">
        <SheetContent side="bottom" class="rounded-t-2xl">
            <SheetHeader><SheetTitle>Game menu</SheetTitle><SheetDescription>Your game continues while you browse.</SheetDescription></SheetHeader>
            <nav class="flex flex-col gap-4 py-5" @click="gameMenu = false">
                <RouterLink to="/?browse=1">Browse Home</RouterLink>
                <RouterLink to="/settings">Settings</RouterLink>
                <RouterLink to="/profile">My profile</RouterLink>
            </nav>
        </SheetContent>
    </Sheet>

    <BasicLayout>
        <div :class="layoutClass">
            <slot />
        </div>
    </BasicLayout>
    <PlayAction v-if="showAction" />
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useRoute } from "vue-router/auto";
import { useGameStore } from "@/stores/game";
import { useLobbyStore } from "@/stores/lobby";
import PlayAction from "@/components/menu/PlayAction.vue";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import DesktopMenu from "@/components/menu/DesktopMenu.vue";
import MobileHeader from "@/components/menu/MobileHeader.vue";
import { useMobile } from "@/helpers/ui";
import BasicLayout from "./BasicLayout.vue";

const route = useRoute();
const game = useGameStore();
const lobby = useLobbyStore();
const gameMenu = ref(false);
const inGameView = computed(() => route.path === "/" && !!game.myUuid && route.query.browse !== "1");
// On desktop Home the Play panel replaces the dock, which stays only to return to a game.
const showAction = computed(() => !inGameView.value && (route.path === "/"
    ? (useMobile.value ? lobby.lobbyID <= 0 : false) || !!game.myUuid
    : !useMobile.value && (!!game.myUuid || lobby.lobbyID > 0)));

const layoutClass = computed(() => {
    if (inGameView.value) return [];
	if (useMobile.value) {
        return showAction.value ? "mobile-with-play" : "mobile-content";
	}
    return ["desktop-content", { "pb-28": showAction.value }];
});
</script>
<style scoped>
.mobile-content { padding-bottom: env(safe-area-inset-bottom); }
.mobile-with-play { padding-bottom: calc(88px + env(safe-area-inset-bottom)); }
</style>
